import ReactSubscribable from './base/ReactSubscribable';
import EndpointService from '../../HTTP/EndpointService';
import AuthenticationService from '.';

import { AUTHENTICATION_SERVER_URL } from '../../configuration';


class PasskeyService extends ReactSubscribable {

    authenticationServer = AUTHENTICATION_SERVER_URL;
    authenticationToken = '';
    reactSubscribers = [];

    state = {
        
    }


    async registrationStart() {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-registration-start', {});
        console.log("trying to register", response);
        return response;
    }

    async registrationEnd(registrationResponse) {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-registration-end', registrationResponse);
        AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        return response;
    }

    async preRegistrationStart() {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-pre-registration-start', {});
        console.log("trying to register", response);
        return response;
    }

    async preRegistrationEnd(registrationResponse) {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-pre-registration-end', registrationResponse);
        AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        return response;
    }

    async loginStart(token) {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-login-start', token);
        AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        return response.options;
    }

    async loginEnd(loginResponse) {
        let response = await EndpointService.post(AUTHENTICATION_SERVER_URL + '/passkey-login-end', loginResponse);
        AuthenticationService.processSuccessfullAuthenticationResponse({data:response});
        return response;
    }
}

export default new PasskeyService();